if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
    }

    hide(preventFocus = false) {
      const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cartNotification) cartNotification.setActiveElement(this.openedBy);
      this.modalContent.innerHTML = '';

      if (preventFocus) this.openedBy = null;
      super.hide();
    }

    show(opener) {
      opener.setAttribute('aria-disabled', true);
      opener.classList.add('loading');
      opener.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      fetch(opener.getAttribute('data-product-url'))
        .then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
          this.preventDuplicatedIDs();
          this.removeDOMElements();
          this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }

          if (window.ProductModel) window.ProductModel.loadShopifyXR();

          
          //console.log(responseHTML.querySelector('section[id^="MainProduct-"]').getAttribute("data-section");)
          
          var parentLink = document.querySelector('.quick-add-modal__content-info .product--large');
          var productBg = document.createElement('div');
          productBg.classList.add('product-bg');
          var firstChild = parentLink.children[1];
          parentLink.insertBefore(productBg, firstChild);
          var productTitle = document.createElement('div');
          productTitle.classList.add('product-title');
          productBg.appendChild(productTitle);
          var productPrice = document.createElement('div');
          productPrice.classList.add('product-price');
          productBg.appendChild(productPrice);
          
          var productPrice1 = document.createElement('div');
          productPrice1.classList.add('product-price1');
          productPrice1.classList.add('strike-through');
          productPrice.appendChild(productPrice1);
          
          var productPrice2 = document.createElement('div');
          productPrice2.classList.add('product-price2');
          productPrice.appendChild(productPrice2);
          
          
    
          

          
          var quickShopTitle = document.querySelector('.product-title');
          var quickShopPrice = document.querySelector('.product-price1');
          var quickShopPrice2 = document.querySelector('.product-price2');
          
          
          var pdTitle = document.querySelector('.quick-add-modal__content-info .product--large .product__info-container .product__title h1');
          
          var pdPrice = document.querySelector('.quick-add-modal__content-info .product--large .product__info-container .quick-shop-regular');
          var pdPrice2 = document.querySelector('.quick-add-modal__content-info .product--large .product__info-container .quick-shop-sale');
         
          var pdVariant = document.querySelector('.product__info-wrapper .product__info-container variant-radios fieldset.product-form__input');
          
          
         
          
          if (pdTitle) quickShopTitle.innerHTML = pdTitle.textContent;

if (pdPrice2 && pdPrice2.textContent.trim()) {
  // On sale: regular price struck through, sale price shown
  if (pdPrice) quickShopPrice.innerHTML = pdPrice.textContent;
  quickShopPrice2.innerHTML = pdPrice2.textContent;
} else {
  // Not on sale: show the regular price only, no strike-through
  if (pdPrice) quickShopPrice2.innerHTML = pdPrice.textContent;
  quickShopPrice.remove();
}

          var mediaWrapper = document.querySelector('.quick-add-modal__content-info .product--large .product__media-wrapper');
          var pdtBg = document.querySelector('.quick-add-modal__content-info .product--large .product-bg');
          var thirdDiv = document.querySelector('.quick-add-modal__content-info .product--large .product__info-wrapper');
          
          var displayPdImageNTitle = document.createElement('div');
          displayPdImageNTitle.classList.add('displayPdImageNTitle');
          var firstMediaChild = parentLink.children[0];
          parentLink.insertBefore(displayPdImageNTitle, firstMediaChild);
          displayPdImageNTitle.appendChild(mediaWrapper);
          displayPdImageNTitle.appendChild(pdtBg);

          var pdDetails = document.querySelector('.quick-add-modal__content-info .product--large .product__info-wrapper .product__info-container .product__view-details');
var productDetails = document.createElement('div');
productDetails.classList.add('product-Details');
productBg.appendChild(productDetails);
if (pdDetails) productDetails.innerHTML = pdDetails.outerHTML;
          this.removeGalleryListSemantic();
          this.updateImageSizes();
          this.preventVariantURLSwitching();
          super.show(opener);
        })
        .finally(() => {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          opener.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }
    
    setInnerHTML(element, html) {
      element.innerHTML = html;

      // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
      element.querySelectorAll('script').forEach(oldScriptTag => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach(attribute => {
          newScriptTag.setAttribute(attribute.name, attribute.value)
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });
    }

    preventVariantURLSwitching() {
      const variantPicker = this.modalContent.querySelector('variant-radios,variant-selects');
      if (!variantPicker) return;

      variantPicker.setAttribute('data-update-url', 'false');
    }

    removeDOMElements() {
      const pickupAvailability = this.productElement.querySelector('pickup-availability');
      if (pickupAvailability) pickupAvailability.remove();

      const productModal = this.productElement.querySelector('product-modal');
      if (productModal) productModal.remove();

      const modalDialog = this.productElement.querySelectorAll('modal-dialog');
      if (modalDialog) modalDialog.forEach(modal => modal.remove());
    }

    preventDuplicatedIDs() {
      const sectionId = this.productElement.dataset.section;
      this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${ sectionId }`);
      this.productElement.querySelectorAll('variant-selects, variant-radios, product-info').forEach((element) => {
        element.dataset.originalSection = sectionId;
      });
    }

    removeGalleryListSemantic() {
      const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
      if (!galleryList) return;

      galleryList.setAttribute('role', 'presentation');
      galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
    }

    updateImageSizes() {
      const product = this.modalContent.querySelector('.product');
      const desktopColumns = product.classList.contains('product--columns');
      if (!desktopColumns) return;

      const mediaImages = product.querySelectorAll('.product__media img');
      if (!mediaImages.length) return;

      let mediaImageSizes = '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';
      
      if (product.classList.contains('product--medium')) {
        mediaImageSizes = mediaImageSizes.replace('715px', '605px');
      } else if (product.classList.contains('product--small')) {
        mediaImageSizes = mediaImageSizes.replace('715px', '495px');
      }

      mediaImages.forEach(img => img.setAttribute('sizes', mediaImageSizes));
    }
  });
}

function triggerQuickBasket(ev){
  //document.querySelector('open.quick-add-modal .product product-info product-form form').click();
  let parentEle = ev.currentTarget.parentNode;
  const form = parentEle.parentNode.querySelector('.product .product__info-wrapper .buy-button form button');
  let id = form.getAttribute("id");
  document.getElementById(id).click();;
}